(function () {
  "use strict";

  DeleteSeriesCtrl.$inject = ['$scope', '$rootScope', '$timeout'];
  angular
    .module('trainerWebApp.modals')
    .controller('DeleteSeriesCtrl', DeleteSeriesCtrl);

  function DeleteSeriesCtrl($scope, $rootScope, $timeout) {

    $scope.modal = {
      content: 0,
      data: {},
      status: '',
      confirmed:false
    };

    $scope.deleteSeries = function() {
      $scope.modal.status = 'saving';
      $scope.modal.confirmed = true;
      $rootScope.$broadcast('seriesDeletionConfirmedEvent', $scope.modal.data, function() {
        $scope.dismiss();
        $timeout(function() {
          $scope.modal.status = ''
        }, 500);
      });
    };

    $scope.$on('seriesDeletionRequestedEvent', function(event, series) {
      $scope.modal.status = '';
      $scope.modal.data = series.id;
      $scope.modal.content = series.name;
      $scope.modal.confirmed = false;
      $scope.show();
    });

  }

})();
